module.exports = __webpack_public_path__ + "static/campaign-entries-a9ef467fa0f427d42ebaccc6cf134976.png";